import { Compass } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/EmptyState";
import { PageContainer } from "@/components/PageContainer";

export function NotFoundPage() {
  return (
    <PageContainer>
      <EmptyState
        icon={Compass}
        title="Pagina non trovata"
        description="L'indirizzo richiesto non corrisponde a nessuna sezione del portale. Torna alla panoramica per orientarti."
        action={
          <Button asChild>
            <Link to="/">Torna alla panoramica</Link>
          </Button>
        }
      />
    </PageContainer>
  );
}
